import React from 'react';
import BaseProps from '../common/interface/BaseProps';

export class Java extends React.Component<BaseProps> {
  render() {
    return (
      <svg
        className={this.props.className}
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
      >
        <g>
          <path
            fill="#5382A1"
            d="M24.69,59.77c0-2.68,10.15-4.18,14.88-4.54l0.45,0.26c-1.82,0.33-9.1,1.61-9.1,3.29   c0,1.82,11.17,3.02,17.66,3.02c11.02,0,18.5-1.67,20.52-2.22l2.82,1.64c-1.93,0.95-10.21,3.42-23.33,3.42   C33.99,64.65,24.69,61.79,24.69,59.77 M46.91,97.33c-5.77,0.05-12.82-0.43-18.75-1.42l-0.55,0.32c5.91,1.73,14.13,2.78,23.16,2.7   c17.74-0.15,32.12-4.55,32.41-9.85l-0.2-0.12C81.79,90.41,74.11,97.1,46.91,97.33 M48.42,93.92c14.52-0.13,30.76-2.97,30.72-7.75   c-0.01-0.87-0.57-1.46-1.06-1.82l-0.24,0.14c-1.34,3.7-12.69,6.43-29.45,6.58c-10.81,0.1-25.8-2.5-25.82-5.49   c-0.03-3,7.1-4.65,7.1-4.65l-0.5-0.28c-4.77,0.66-13.57,2.94-13.54,6.24C15.67,91.66,35.88,94.03,48.42,93.92 M81.13,61.05   c-0.29,5.6-5.47,9.09-10.64,12.04l0.47,0.27c5.52-1.55,15.37-6.07,14.55-13.02c-0.41-3.47-3.58-5.94-7.71-5.94   c-1.28,0-2.43,0.23-3.35,0.51l0,0.01l-0.2,0.49C77.95,54.68,81.32,57.37,81.13,61.05 M38.48,77.69c-1.68,0.34-5.36,1.18-5.36,2.96   c0,2.47,7.86,4.37,15.45,4.37c10.43,0,14.71-2.69,14.9-2.83l-4.34-2.51c-1.85,0.44-4.96,1.13-10.55,1.13   c-6.25,0-10.32-1.07-10.32-2.24c0-0.25,0.15-0.54,0.45-0.76L38.48,77.69z M64.12,69.36c-2.4,0.68-7.81,1.79-15.54,1.79   c-7.59,0-13.79-1.3-13.81-2.83c-0.01-1.02,1.22-1.46,1.22-1.46l-0.22-0.13c-3.63,0.64-7.01,1.64-6.99,3.12   c0.03,2.7,10.35,4.72,19.78,4.72c8.02,0,15.73-1.35,19.2-3.11L64.12,69.36z"
          />
          <path
            fill="#F8981D"
            d="M62.05,9.2c0,14.87-20.38,20.56-20.38,31.13c0,7.42,4.92,12.07,7.64,15.02l-0.22,0.13   c-3.43-2.15-12.48-7.56-12.48-16.48c0-12.53,23.4-18.52,23.4-32.75c0-1.75-0.26-3.09-0.44-3.82l0.24-0.14   C60.56,3.22,62.05,5.55,62.05,9.2 M68.75,22.37l-0.24-0.14c-4.44,1.49-18.09,6.87-18.09,16.92c0,5.68,5.55,8.83,5.55,14.16   c0,1.9-1.07,3.68-1.95,4.75l0.44,0.25c2.31-1.5,6.4-4.75,6.4-8.95c0-3.55-4.92-7.82-4.92-12.39   C55.94,29.77,65.43,24.12,68.75,22.37"
          />
        </g>
      </svg>
    );
  }
}
